<style scoped>
</style>

<template>
  <section class="container">
    <img src="../../assets/images/print_tela_agenda.png"/>
  </section>
</template>

<script>
  export default {
    mounted () {
      let possuiPermissao
      this.$store.state.menu.forEach(item => {
        if (item.sub_menus.filter(sub => sub.link === '/agenda').length > 0) {
          possuiPermissao = true
        }
      })
      if (!possuiPermissao) {
        this.$router.push('/403')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/agenda/Dashboard.vue